module.exports = {"id":"178284","name":"Lee Nguyen","rating":"76","photo":"./data/images/photos/1/178284.png","club":{"name":"New England","logo":"./data/images/clubs/NewEngland.png"},"positions":["MOC","MC","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeeNguyen0.json
// module id = 2467
// module chunks = 0